import {DOCUMENT} from '@angular/common';
import {Inject, Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SystemStoreFacadeService} from '../store/system-store-facade.service';
import { UserSessionStoreService as StoreService } from '@drl/core/store/user-session-store.service';
import * as moment from 'moment';

@Injectable()
export class IpsTranslateService {
  constructor(
    public translate: TranslateService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    private readonly store: StoreService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {}

  init(locale?:string) {
    this.translate.setDefaultLang(locale?locale:'en');
    this.systemStoreFacade.getLocale().subscribe(locale => {
      this.document.documentElement.lang = locale;
      this.translate.use(locale).subscribe();
      this.store.setLocale(locale);
      moment.locale(locale)
    });
  }
}
